/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAirConditioningDisabled = createReactComponent("outline", "air-conditioning-disabled", "IconAirConditioningDisabled", [["path", { "d": "M3 8m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 16v-3a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v3", "key": "svg-1" }]]);

export { IconAirConditioningDisabled as default };
//# sourceMappingURL=IconAirConditioningDisabled.mjs.map
